import React, { useState } from 'react';

type PropsTdSeeMoreContent = {
    lengthToSee:number,
    text:string
}

const TdSeeMoreContent = (props:PropsTdSeeMoreContent) => {
    const {lengthToSee,text} = props
    
    const [showFullText, setShowFullText] = useState(false);

    const toggleShowFullText = () => {
        setShowFullText(!showFullText);
    };

    return (
        <>
            {showFullText ? (
                <div className='small-error'>
                    {text}
                    <div>
                        <span className="see-less" onClick={toggleShowFullText}>
                            Ver menos
                        </span>
                    </div>  
                </div>
            ) : (
                <div className='small-error'>
                    {text.slice(0, lengthToSee) + "..."} {/* Display first 100 characters, adjust as needed */}
                    {text.length > lengthToSee && (
                        <span className="see-more" onClick={toggleShowFullText}>
                            Ver más
                        </span>
                    )}
                </div>
            )}
        </>
    );
};

export default TdSeeMoreContent;